export default __webpack_public_path__ + "static/5-161f9fcfe0a96ac963b5ecb5b24a707b.png";